import React, { FC } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

interface Props {
  onConfirm: () => void;
}

const ProjectSwitchOverlay: FC<Props> = ({ onConfirm }) => (
  <Dialog
    open
    maxWidth="xs"
    fullWidth
    disableEscapeKeyDown
    aria-label="Cambio de inmobiliaria en otra pestaña"
    sx={{ zIndex: 10000 }}
    PaperProps={{
      sx: {
        borderRadius: '8px',
        border: '1px solid rgba(226, 232, 240, 0.5)',
        boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.1), 0px 20px 20px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      },
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 20px',
        backgroundColor: 'rgba(241, 245, 249, 0.3)',
        borderBottom: '1px solid rgba(226, 232, 240, 0.3)',
      }}
    >
      <Typography
        sx={{ fontSize: '16px', fontWeight: 700, color: '#020817', letterSpacing: '-0.4px', lineHeight: 1.5 }}
      >
        Cambiaste de inmobiliaria en otra pestaña
      </Typography>
    </Box>

    {/* Content */}
    <Box sx={{ padding: '16px 20px' }}>
      <Typography sx={{ fontSize: '13px', color: '#64748b', lineHeight: 1.4 }}>
        Recarga esta pestaña para ver los datos de tu inmobiliaria actual.
      </Typography>
    </Box>

    {/* Footer */}
    <Box
      sx={{
        display: 'flex',
        padding: '16px 20px',
        backgroundColor: 'rgba(241, 245, 249, 0.2)',
        borderTop: '1px solid rgba(226, 232, 240, 0.3)',
      }}
    >
      <Button
        variant="contained"
        onClick={onConfirm}
        sx={{
          flex: 1,
          height: '36px',
          borderRadius: '6px',
          textTransform: 'none',
          fontSize: '14px',
          backgroundColor: '#0f172a',
          color: '#f8fafc',
          boxShadow: 'none',
          '&:hover': { backgroundColor: '#0f172a', boxShadow: 'none' },
        }}
      >
        Recargar
      </Button>
    </Box>
  </Dialog>
);

export default ProjectSwitchOverlay;
